import { render, staticRenderFns } from "./TekaChatComponent.vue?vue&type=template&id=22a36bb0"
import script from "./TekaChatComponent.vue?vue&type=script&lang=js"
export * from "./TekaChatComponent.vue?vue&type=script&lang=js"
import style0 from "./TekaChatComponent.vue?vue&type=style&index=0&id=22a36bb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports